import React, { useState, useEffect } from 'react'
import { useMutation, useDataProvider } from 'react-admin'
import { TextField } from '@material-ui/core'

const ChangeProxyInput = (props) => {
    let { record, setHasProxyChanged } = props
    let { proxy: proxyFromDB, id: idFromDB } = record
    const [newProxy, setProxy] = useState(proxyFromDB ? proxyFromDB : 0)
    const [newID, setID] = useState(idFromDB)

    useEffect(() => {
        let { record } = props;
        let { proxy: proxyFromDB, id: idFromDB } = record
        setProxy(proxyFromDB ? proxyFromDB : 0)
        setID(idFromDB)

    }, [props.record])

    const inputProps = {
        step: 100,
        min: 0
    };

    const [mutate, { loading }] = useMutation({
        type: 'update',
        resource: 'tradeRev-auto-proxys',
        payload: { id: newID, data: { proxy: newProxy, proxy_changed: true } }
    });

    const dataProvider = useDataProvider();


    const handleOnBlur = () => {
        if (newProxy != proxyFromDB) {
            // setHasProxyChanged(true)
            mutate()
            dataProvider.getOne('tradeRev-auto-proxys', { id: newID })
        }
    }


    return (
        <TextField
            id={idFromDB ? idFromDB.toString() : ''}
            label="Current Proxy"
            type="number"
            onChange={(e) => setProxy(e.target.value)}
            onBlur={handleOnBlur}
            inputProps={inputProps}
            value={newProxy}
            InputLabelProps={{ shrink: true, }}
        />

    )
}

export default ChangeProxyInput